import ACLService from "@/api/acl.service";

const state = () => ({
  roles: []
});
const getters = {
  GetRoles: state => {
    return state.roles;
  }
};
const mutations = {
  SET_ROLES_STATE: (state, rolesData) => {
    state.roles = rolesData;
  }
};
const actions = {
  /**
   * fetch all available user roles
   * @param   {Object}    context   vuejs context object commit|dispact
   * @return  {Object}    sets roles state with new roles
   */
  FetchUserRoles: async context => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await ACLService.roles(authToken);
      context.commit("SET_ROLES_STATE", response.data);
    } catch (error) {
        return error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
